import api from './api';
import { ApiResponse, ImagemRelatorio, OrientacaoRelatorio } from '../types';

export const imagemRelatorioService = {
  listar: async (): Promise<ImagemRelatorio[]> => {
    const response = await api.get<ImagemRelatorio[]>('/imagens');
    return response.data;
  },

  buscarPorOrientacao: async (orientacao: OrientacaoRelatorio): Promise<ImagemRelatorio> => {
    const response = await api.get<ImagemRelatorio>(`/imagens/${orientacao}`);
    return response.data;
  },

  salvar: async (orientacao: OrientacaoRelatorio, img: string): Promise<ApiResponse<ImagemRelatorio>> => {
    const response = await api.put<ApiResponse<ImagemRelatorio>>(`/imagens/${orientacao}`, { img });
    return response.data;
  },

  remover: async (orientacao: OrientacaoRelatorio): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/imagens/${orientacao}`);
    return response.data;
  },
};
